import Vue from 'vue'
import VueRouter from 'vue-router'
import CampaignEdit from '../pages/Campaigns/campaign-edit'
import CampaignShow from '../pages/Campaigns/CampaignShow'
import AutoCampaignEdit from '../pages/AutoCampaigns/AutoCampaignEdit'
import AutoCampaignShow from '../pages/AutoCampaigns/AutoCampaignShow'
import LoyaltyPoints from '../pages/LoyaltyPoints'
import PinsReport from '../pages/Reports/PinsReport';
import CheckInReport from '../pages/Reports/CheckInReport';
import RedemptionReport from '../pages/Reports/RedemptionReport';
import UserPermissionsReport from '../pages/Reports/UserPermissionsReport';
import ImpactReportIndex from '../pages/Reports/ImpactReport/Index'
import ImpactReport from '../pages/Reports/ImpactReport/Report'
import InquiryReport from '../pages/Reports/InquiryReport/Report'
import SharingLinks from '../pages/MerchantSettings/SharingLinks'
import UsersIndex from '../pages/Users/UsersIndex'
import UsersEdit from '../pages/Users/UsersEdit'
import Program from '../pages/MerchantSettings/Program'
import CashRewardsProgram from '../pages/MerchantSettings/CashRewardsProgram'
import SpenceLanding from '../pages/MerchantSettings/SpenceLanding'
import Passcode from '../pages/Passcode/Passcode'
import Stashboard from '../pages/Stashboard/Stashboard'
import BrandsMarketplace from '../pages/BrandsMarketplace/BrandsMarketplace'
import Feedback from '../pages/Feedbacks/Feedback'
import StashboardSettings from "../pages/MerchantSettings/StashboardSettings.vue";
import MemberOfferEdit from "../pages/MemberOffers/MemberOfferEdit"
import RewardEdit from "../pages/Rewards/RewardEdit";
import { beforeEach } from '@springbig/sb-components';

Vue.use(VueRouter)

const router =  new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/campaigns/:id/edit',
      name: 'CampaignEdit',
      component: CampaignEdit
    },
    {
      path: '/campaigns/:id',
      name: 'CampaignShow',
      component: CampaignShow,
    },
    {
      path: '/classic_campaigns/:id/edit',
      name: 'ClassicCampaignEdit',
      component: CampaignEdit,
    },
    {
      path: '/classic_campaigns/:id',
      name: 'ClassicCampaignShow',
      component: CampaignShow
    },
    {
      path: '/auto_campaigns/:id/edit',
      name: 'AutoCampaignEdit',
      component: AutoCampaignEdit,
    },
    {
      path: '/auto_campaigns/:id',
      name: 'AutoCampaignShow',
      component: AutoCampaignShow,
      beforeEnter: (to, from, next) => {
        const routesToSkip = ['budz', 'start']
        if (!routesToSkip.includes(to.params.id)) { next() }
      }
    },
    {
      path: '/reports/pins',
      name: 'PinsReport',
      component: PinsReport,
    },
    {
      path: '/reports/check_in',
      name: 'CheckInReport',
      component: CheckInReport,
    },
    {
      path: '/reports/redemptions',
      name: 'RedemptionReport',
      component: RedemptionReport,
    },
    {
      path: '/reports/user_permissions',
      name: 'UserPermissionsReport',
      component: UserPermissionsReport,
    },
    {
      path: '/reports/loyalty_points',
      name: 'LoyaltyPoints',
      component: LoyaltyPoints,
    },
    {
      path: '/reports/impact',
      name: 'ImpactReport',
      component: ImpactReportIndex,
    },
    {
      path: '/reports/impact/new',
      name: 'ImpactReportNew',
      component: ImpactReport,
    },
    {
      path: '/reports/impact/:id',
      name: 'ImpactReportShow',
      component: ImpactReport,
    },
    {
      path: '/reports/inquiry',
      name: 'InquiryReport',
      component: InquiryReport,
    },
    {
      path: '/merchants/:id/sharing',
      name: 'SharingLinks',
      component: SharingLinks,
    },
    {
      path: '/merchants/:id/program',
      name: 'Program',
      component: Program,
    },
    {
      path: '/merchants/:id/cash_rewards_program',
      name: 'CashRewardsProgram',
      component: CashRewardsProgram,
    },
    {
      path: '/merchants/:id/spence_landing',
      name: 'SpenceLanding',
      component: SpenceLanding,
    },
    {
      path: '/merchants/:id/stashboard_settings',
      name: 'StashboardSettings',
      component: StashboardSettings,
    },
    {
      path: '/users',
      name: 'UsersIndex',
      component: UsersIndex
    },
    {
      path: '/users/:id/edit',
      name: 'UsersEdit',
      component: UsersEdit
    },
    {
      path: '/users/new',
      name: 'UsersNew',
      component: UsersEdit
    },
    {
      path: '/passcode/:id',
      name: 'Passcode',
      component: Passcode
    },
    {
      path: '/stashboard/:id',
      name: 'Stashboard',
      component: Stashboard,
      props: true
    },
    {
      path: '/brands_marketplace',
      name: 'BrandsMarketplace',
      component: BrandsMarketplace,
    },
    {
      path: '/feedback',
      name: 'Feedback',
      component: Feedback
    },
    {
      path: '/member_offers/:id/edit',
      name: 'MemberOfferEdit',
      component: MemberOfferEdit
    },
    {
      path: '/rewards/:id/edit',
      name: 'RewardEdit',
      component: RewardEdit
    }
  ]
});

router.beforeEach(beforeEach);

export default router
